import { Component, OnInit, Input, Output, ViewChild } from '@angular/core';
import { MAT_MENU_DEFAULT_OPTIONS, MatMenuTrigger } from '@angular/material/menu';
import { AccountTag } from 'app/entities/account-tag';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-card-drop-down-tag-create',
  templateUrl: './card-drop-down-tag-create.component.html',
  styleUrls: ['./card-drop-down-tag-create.component.scss'],
  providers: [
    {
      provide: MAT_MENU_DEFAULT_OPTIONS,
      useValue: { overlayPanelClass: 'form-menu' }
    }
  ]
})
export class CardDropDownTagCreateComponent implements OnInit {

  @Input('appearance') appearance: string = 'standard';
  @Input('tag') tag: AccountTag | null = null;
  @ViewChild('menuTrigger') menuTrigger!: MatMenuTrigger;
  @Output() onCreated = new Subject<AccountTag>();
  @Output() onUpdated = new Subject<AccountTag>();

  menuOpen = false;
  loading = false

  constructor(
    
  ) { }

  ngOnInit(): void {

  }

  open() {
    this.menuTrigger.openMenu(); // Open the menu
    this.menuOpen = true;
  }

  created(tag: AccountTag) {
    this.onCreated.next(tag)
    this.close();
  }

  updated(tag: AccountTag) {
    this.close();
    this.onUpdated.next(tag)
  }

  close() {
    this.menuOpen = false;
    this.menuTrigger.closeMenu()
  }

  getButtonClass() {
    switch (this.appearance) {
      case 'mat-menu-item':
        return 'mat-menu-item mat-focus-indicator';
      default:
        return 'btn btn-green';
    }
  }

}
